var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStack(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.2l6.542-4.584L16 5.6 8 0 0 5.6l1.449 1.016L8 11.2zm0 2.032L1.44 8.648 0 9.656l8 5.6 8-5.6-1.449-1.016L8 13.232z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.f4deef3798275fd6690b5a0e1a088a5f.svg";
export { ForwardRef as ReactComponent };